export const etapasConfiguracaoEnum = {
    DATA: "data",
    DEPARTAMENTOS: "departamentos",
    EMPRESAS: "empresas"
}